import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { get, filter } from "lodash";

import TableRow from "@material-ui/core/TableRow";

//import Picture from "../../Common/Picture";
import TagColor from "../../Common/TagColor";
import TableCellStyled from "../../Common/TableCellStyled";
import ProfilePictureAndLink from "../../Common/ProfilePictureAndLink";

//import { getAttributeValue } from "../../../utils/profile";
import { displayBoolean, displayData } from "../../../utils/data";

import colors from "../../../assets/style/colors";
//import images from "../../../assets/img/images";

const styles = {
  tableRow: {
    height: "50px",
    maxHeight: "50px",
  },
  tableRowHover: {
    "&:hover": {
      cursor: "pointer",
      backgroundColor: `${colors.lightGreenBg} !important`,
    },
  },
};

const ProfileRow = (props) => {
  const { classes, history, profile, index, language } = props;

  const redirectToProfile = () => {
    history.push(`profiles/${get(profile, ["id"])}`);
  };

  // const pictureUrl =
  //   get(profile, ["type", "id"]) === 1
  //     ? get(
  //         filter(
  //           get(profile, ["images"]),
  //           (img) => img.active && img.enrollment_status
  //         ),
  //         [0, "url"]
  //       )
  //     : get(
  //         filter(get(profile, ["images"]), (img) => img.active),
  //         [0, "url"]
  //       );

  return (
    <TableRow
      data-automation={`profiles_list_table_row_${index}`}
      style={
        index % 2
          ? { backgroundColor: colors.tableDarkBg }
          : { backgroundColor: colors.white }
      }
      hover={true}
      classes={{
        root: classes.tableRow,
        hover: classes.tableRowHover,
      }}
    >
      <TableCellStyled
        data-automation={`profiles_list_table_column_0_row_${index}`}
        className="text-54"
        onClick={redirectToProfile}
      >
        {get(profile, ["type", `name_${language}`])}
      </TableCellStyled>
      <TableCellStyled
        data-automation={`profiles_list_table_column_1_row_${index}`}
        onClick={redirectToProfile}
      >
        <ProfilePictureAndLink
          profile={profile}
          maxHeight={40}
          maxWidth={40}
          noLink
        />
      </TableCellStyled>
      <TableCellStyled
        data-automation={`profiles_list_table_column_2_row_${index}`}
        onClick={redirectToProfile}
      >
        <TagColor
          color={get(profile, ["tag", "color_rgb"])}
          name={get(profile, ["tag", `name_${language}`])}
        />
      </TableCellStyled>
      <TableCellStyled
        data-automation={`profiles_list_table_column_3_row_${index}`}
        className="text-54"
        onClick={redirectToProfile}
      >
        {displayData(
          get(
            filter(get(profile, ["attributes"]), (attr) => attr.id === 89),
            [0, "picklist", `name_${language}`]
          )
        )}
      </TableCellStyled>
      <TableCellStyled
        data-automation={`profiles_list_table_column_4_row_${index}`}
        className="text-54"
        onClick={redirectToProfile}
      >
        {displayBoolean(get(profile, ["active"]))}
      </TableCellStyled>
      <TableCellStyled
        data-automation={`profiles_list_table_column_5_row_${index}`}
        className="text-54"
        onClick={redirectToProfile}
      >
        {get(profile, ["note_count"])}
      </TableCellStyled>
      {/* <TableCellStyled
        data-automation={`profiles_list_table_column_6_row_${index}`}
      >
        {pictureUrl ? (
          <Picture
            url={pictureUrl}
            maxHeight={40}
            justify="flex-start"
            style={{
              maxWidth: "40px",
              maxHeight: "40px",
              borderRadius: "4px",
            }}
            alt="profile_photo"
          />
        ) : (
          <span style={{ display: "flex" }}>
            <img src={images.noPicture} alt="no_photo" />
          </span>
        )}
      </TableCellStyled> */}
    </TableRow>
  );
};

export default withRouter(withStyles(styles)(ProfileRow));
